module.exports = __webpack_public_path__ + "static/media/ajax-loader.9a039b5f.gif";